<template>
    <div class="content">
        <div class="container">
            <div class="mg-t-60">
                <div class="row">
                    <div class="col-sm"></div>
                    <div class="col-sm-8">
                        <div class="card" v-if="taskDetail.rdy">
                            <div class="card-header">Үндсэн мэдээлэл</div>
                            <div class="card-body bg-white">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <ul class="list-group">
                                    <li class="list-group-item d-flex align-items-center justify-content-center" style="padding: 0; margin: 0">
                                        <img :src="`${$store.state.user.userInfo.avator}`" class="wd-100 rounded mg-r-15" alt="">
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ taskDetail.obj.st2 }}</h6>
                                            <span class="d-block tx-11 text-muted">Ургийн овог</span>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ $store.state.user.userInfo.ovog }}</h6>
                                            <span class="d-block tx-11 text-muted">Эцэг/Эх-н нэр</span>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ $store.state.user.userInfo.ner }}</h6>
                                            <span class="d-block tx-11 text-muted">Нэр</span>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ taskDetail.obj.langCode }}</h6>
                                            <span class="d-block tx-11 text-muted">Регистр №</span>
                                        </div>
                                    </li>
                                </ul>
                                    </div>
                                    <div class="col-sm-6">
                                        <ul class="list-group">
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ taskDetail.obj.address }}</h6>
                                            <span class="d-block tx-11 text-muted">Хаяг</span>
                                        </div>
                                    </li>

                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ taskDetail.obj.mobile }}</h6>
                                            <span class="d-block tx-11 text-muted">Утас</span>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex align-items-center">
                                        <div>
                                            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ taskDetail.obj.loginName }}</h6>
                                            <span class="d-block tx-11 text-muted">Иргэний код</span>
                                        </div>
                                    </li>
                                </ul>

                                <div class="mg-t-10 alert alert-info">Иргэний дараах мэдээллийг системд татах гэж байна. Та зөвшөөрч байна уу ?</div>

                                <div class="pd-10">
                                        <div class="d-flex">
                                            <a @click="logout()" class="btn btn-danger btn-sm" role="button">Системээс гарах</a>
                                            <a @click="fetchData()" class="mg-l-auto btn btn-success btn-sm" role="button">Мэдээлэл татах</a>
                                        </div>
                                    </div>

                                    </div>
                                    
                                </div>
                                
                            </div>
                            </div>
                        </div>
                    <div class="col-sm"></div>
                </div>
                <div class="row">
                    <div class="col-sm"></div>
                    <div class="col-sm-8">
                        <div class="card">
                            <div class="card-header">Иргэний дүүргэсэн дээд сургуулиудын мэдээлэл</div>
                            <div class="card-body bg-white">
                                <el-table v-if="graduateSchool.code==0" :data="graduateSchool.list" border>
                                    <el-table-column prop="institutionName" label="Сургууль" />
                                    <el-table-column prop="programName" label="Хөтөлбөр" />
                                    <el-table-column prop="dergeeName" label="Зэрэг"/>
                                    <el-table-column prop="conferYear" label="Төгссөн" width="80"/>
                                    <el-table-column prop="educationId" label="Дипломын дугаар" width="150"/>
                                </el-table>
                                <div v-else class="alert alert-warning">{{ graduateSchool.msg }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm"></div>
                </div>

                <div class="row">
                    <div class="col-sm"></div>
                    <div class="col-sm-8">
                        <div class="card">
                            <div class="card-header">Бүрэн дунд боловсролын гэрчилгээний мэдээлэл</div>
                            <div class="card-body bg-white">
                                <el-table v-if="highSchool.code==0" :data="highSchool.list" border>
                                    <el-table-column prop="orgName" label="Байгууллагын нэр" />
                                    <el-table-column prop="regnum" label="Регистр" />
                                    <el-table-column prop="lastName" label="Овог"/>
                                    <el-table-column prop="firstName" label="Нэр" />
                                    <el-table-column prop="year" label="Жил" />
                                    <el-table-column prop="degreeNumber" label="Гэрчилгээний дугаар" />
                                </el-table>
                                <div v-else class="alert alert-warning">{{ highSchool.msg }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm"></div>
                </div>

                <div class="row">
                    <div class="col-sm"></div>
                    <div class="col-sm-8">
                        <div class="card">
                            <div class="card-header">Даатгуулагчийн сүүлийн таван жил ажилласан түүх </div>
                            <div class="card-body bg-white">
                                <div v-if="workHistory.code==0" >
                                    <el-table :data="paginatedData1" border>
                                        <el-table-column prop="orgName" label="Байгууллага" />
                                        <el-table-column prop="startDate" label="Эхэлсэн" />
                                        <el-table-column prop="orgRegId" label="Регистр" width="80" />
                                        <el-table-column prop="directorName" label="Захирал" />
                                        <el-table-column prop="directorPhone" label="Утас" width="120"/>
                                    </el-table>
                                    <div class="text-right">
                                        <el-pagination class="mg-t-10"
                                            @current-change="handlePageChange1"
                                            :current-page="currentPage1"
                                            :page-size="pageSize1"
                                            :total="totalItems1"
                                            layout="total, prev, pager, next, jumper"
                                            >
                                        </el-pagination>
                                    </div>
                                </div>
                                <div v-else class="alert alert-warning">{{ workHistory.msg }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm"></div>
                </div>

                <div class="row">
                    <div class="col-sm"></div>
                    <div class="col-sm-8">
                        <div class="card">
                            <div class="card-header d-flex">Иргэний нийгмийн даатгалын мэдээлэл 
                                <div class="mg-l-auto"><span class="text-muted">Тайлан он:</span> {{ salaryInfo.request.startYear }} - {{ salaryInfo.request.endYear }}</div>
                            </div>
                            <div class="card-body bg-white">
                                <div v-if="salaryInfo.code==0">
                                    <el-table :data="paginatedData" border>
                                        <el-table-column prop="orgName" label="Байгууллага" />
                                        <el-table-column prop="domName" label="Дүүрэг" />
                                        <el-table-column prop="year" label="Жил" width="80"/>
                                        <el-table-column prop="month" label="Сар" width="80" />
                                        <el-table-column label="Төлсөн" width="100">
                                            <template slot-scope="scope">
                                                {{ scope.row.paid ? 'Тийм' : 'Үгүй' }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="text-right">
                                        <el-pagination class="mg-t-10"
                                            @current-change="handlePageChange"
                                            :current-page="currentPage"
                                            :page-size="pageSize"
                                            :total="totalItems"
                                            layout="total, prev, pager, next, jumper"
                                            >
                                        </el-pagination>
                                    </div>
                                </div>
                                <div v-else class="alert alert-warning">{{ salaryInfo.msg }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";
import { Table, TableColumn, Pagination } from 'element-ui';
var _ = require("lodash");

export default {
    components: { ElTable: Table, ElTableColumn: TableColumn, ElPagination: Pagination },
    data(){
        return{
            taskDetail:{
                obj:{},
                rdy: false
            },
            graduateSchool:{
                code: null,
                msg: null,
                list: []
            },
            highSchool:{
                code: null,
                msg: null,
                list: []
            },
            workHistory:{
                code: null,
                msg: null,
                list: []
            },
            salaryInfo:{
                code: null,
                msg: null,
                list: [],
                request:{
                    startYear: null,
                    endYear: null,
                },
            },
            currentPage: 1,
            pageSize: 5,
            totalItems: 0,

            currentPage1: 1,
            pageSize1: 5,
            totalItems1: 0,
        }
    },
    mounted() {
        //console.log('mntd 1', this.$store);
        let _obj = this.$store.state.app.mainLayoutConfig;
        _obj.aside = false;
        _obj.header = -1;
        _obj.footer = false;
        this.handleMainLayoutConfig(_obj);
        this.init();
        this.initProfile();
    },
    methods:{
        logout(){
            this.handleLoading({ isLoading: true });
            this.handleLogOut({ store: this.$store }).then((res) => {
                if (res != false) {
                this.handleLoading({ isLoading: false });
                this.$router.push({ name: "login" });
                }
            });
        },
        fetchData(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                    api: { url: "Xyp/FetchCitizenData", method: "POST" },
                    store: this.$store
                }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                    if(res!=false){
                        this.$router.push("/user/profile");
                    }
                }
            });
        },
        ...mapActions(["handleLoading", "handleLogOut", "handleAside", "handleMainLayoutConfig"]),
        initProfile(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                    api: { url: "task/taskInheritedDetail", method: "get" },
                    params: { id: this.$store.state.user.userInfo.profileId },
                    store: this.$store
                }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                    // console.log('pro', res);
                    this.taskDetail.obj = res.data.task;
                    this.taskDetail.rdy= true;
                }
            });
        },
        init(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "xyp/citizenGraduateSchoolListData" },
                store: this.$store
            }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                this.initHighSchool();
                if(res!=false){
                    // console.log('res g', res);
                    this.graduateSchool.code= res.data.resultCode;
                    if(res.data.resultCode==0){
                        this.graduateSchool.list= res.data.response.listData;
                    }else{
                        this.graduateSchool.msg= res.data.resultMessage;
                    }
                }
            });
        },
        initHighSchool(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "xyp/getCitizenHighSchoolInfo" },
                store: this.$store
            }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                this.initWorkHistory();
                if(res!=false){
                    this.highSchool.code= res.data.resultCode;
                    if(res.data.resultCode==0){
                        let _obje=res.data.response;
                        // this.highSchool.list= res.data.response.listData;
                        this.highSchool.list= [{
                            orgName: _obje.orgName,
                            regnum: _obje.regnum,
                            lastName: _obje.lastName,
                            firstName: _obje.firstName,
                            year: _obje.year,
                            degreeNumber: _obje.degreeNumber,
                            yearEng: _obje.yearEng,
                            orgNameEng: _obje.orgNameEng,
                            degreeNumberEng: _obje.degreeNumberEng,
                            parentOrgNameEng: _obje.parentOrgNameEng

                        }];
                    }else{
                        this.highSchool.msg= res.data.resultMessage;
                    }
                }
            });
        },
        initWorkHistory(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "xyp/getInsureeWorkHistoryInfo" },
                store: this.$store
            }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                this.initSalaryInfo();
                if(res!=false){
                    //console.log('res', res);
                    this.workHistory.code= res.data.resultCode;
                    if(res.data.resultCode==0){
                        this.workHistory.list= res.data.response.listData;
                        this.totalItems1= res.data.response.listData.length;
                    }else{
                        this.workHistory.msg= res.data.resultMessage;
                    }
                }
            });
        },
        initSalaryInfo(){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "xyp/getCitizenSalaryInfo" },
                store: this.$store
            }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                // this.init();
                if(res!=false){
                    // console.log('res', res);
                    this.salaryInfo.code= res.data.resultCode;
                    if(res.data.resultCode==0){
                        this.salaryInfo.list= _.orderBy(res.data.response.list, ["year", "month"], ["desc", "desc"]);
                        this.salaryInfo.request= res.data.request;
                        this.totalItems= res.data.response.list.length;
                    }else{
                        this.salaryInfo.msg= res.data.resultMessage;
                    }
                }
            });
        },
        handlePageChange1(page) {
            this.currentPage1 = page;
        },
        handlePageChange(page) {
            this.currentPage = page;
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    },
    computed: {
        paginatedData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = this.currentPage * this.pageSize;
            return this.salaryInfo.list.slice(start, end);
        },
        paginatedData1() {
            const start = (this.currentPage1 - 1) * this.pageSize1;
            const end = this.currentPage1 * this.pageSize1;
            return this.workHistory.list.slice(start, end);
        },
    },
}
</script>